<template>
  <div class="user_invite_dialog">
    <el-dialog custom-class="with-title" :title="addUserButtonTitle" :visible.sync="visible">
      <div class="dialog-content">
        <div class="message-container">
          <div class="message message-info">
            追加したいユーザーのメールアドレスを入力してください。<br />入力したメールアドレスに招待メールが送信されます。
          </div>
          <div class="message message-warning" v-if="isGuest">
            ゲストユーザーはアカウントの登録や更新のみができる権限です。<br />詳しくは
            <a href="https://help-atelu.comnico.jp/guest-user" target="_blank">こちら</a>をご確認ください
          </div>
        </div>
        <div class="input-container mt-x1 mb-x2">
          <el-input
            :class="{ error: $v.email.required && $v.email.$error, success: $v.email.required && !$v.email.$invalid }"
            placeholder="メールアドレス"
            :maxlength="100"
            type="text"
            v-model="email"
            @blur="$v.email.$touch"
            tabindex="1"
          >
            <template slot="prepend"><i class="mdi mdi-email"></i></template>
          </el-input>
          <div class="invalid" v-if="!$v.email.required && $v.email.$error">メールアドレスを入力してください。</div>
          <div class="invalid" v-if="!$v.email.email && $v.email.$error">メールアドレスの形式が正しくありません。</div>
        </div>
        <div class="input-container" v-if="!isGuest">
          <el-switch v-model="isUserAdmin" active-text="グループ管理者"></el-switch>
        </div>
      </div>
      <div class="dialog-footer" slot="footer">
        <div layout layout-align="end-center">
          <el-button type="default" @click="close()">キャンセル</el-button>
          <el-button type="primary" @click="inviteUser()" :disabled="$v.$invalid === true"
            ><i class="mdi mdi-account-plus"></i>招待</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.input-container {
  .invalid {
    display: block;
    margin-top: $spacing-unit;
    font-size: $font-small-size;
    color: $danger-color;
  }
}

.message-container {
  display: flex;
  flex-direction: column;
  gap: $spacing-unit;
}
</style>
<script lang="ts">
import { mapState } from 'pinia'
import { defineComponent } from 'vue'
import { email, required } from 'vuelidate/lib/validators'

import api from '@/client/core/api'
import { useSystemStore } from '@/client/store/useSystemStore'

export default defineComponent({
  data() {
    return {
      email: '',
      isUserAdmin: false,
      visible: false,
      isSubmit: false,
      isGuest: false,
      groupId: null as number | null | undefined
    }
  },
  computed: {
    ...mapState(useSystemStore, {
      currentGroup: state => state.currentGroup
    }),
    addUserButtonTitle() {
      return this.isGuest ? 'ゲストユーザーの追加' : 'ユーザーの追加'
    }
  },
  methods: {
    /**
     * 招待情報を保存
     */
    async inviteUser() {
      if (this.isSubmit) {
        return
      }

      this.isSubmit = true
      // 招待情報を保存
      const result = await api.post(
        '/invitations',
        this.isGuest
          ? {
              groupId: this.groupId ?? this.currentGroup?.id,
              email: this.email,
              isGuest: true
            }
          : {
              groupId: this.groupId ?? this.currentGroup?.id,
              email: this.email,
              isUserAdmin: this.isUserAdmin ? 1 : 0
            }
      )

      setTimeout(() => {
        this.isSubmit = false
      }, 2000)

      if (result.error && result.error.type === 'GROUP_USER_EXISTS') {
        this.$notify({
          title: '対象のユーザーはすでに追加されています。',
          message: '',
          customClass: 'danger',
          duration: 5000
        })
        this.close()
        return
      }

      if (result.error && result.error.type === 'GROUP_MAX_USER_COUNT_OVER') {
        this.$notify({
          title: 'これ以上ユーザーを追加できません。',
          message: 'グループの登録可能ユーザー数を超えています。',
          customClass: 'danger',
          duration: 5000
        })
        this.close()
        return
      }

      // エラーがある場合はエラーメッセージを表示
      if (!result.data) {
        this.$notify({
          title: 'ユーザー招待処理に失敗しました。',
          message: '恐れ入りますが、時間をおいて再度お試しください。',
          customClass: 'danger',
          duration: 5000
        })
        this.close()
        return
      }

      // 成功メッセージを表示
      this.$notify({
        title: '招待メールを送信しました。',
        message: '',
        customClass: 'success',
        duration: 5000
      })
      this.close()
    },
    /**
     * ダイアログを開く
     */
    open(group?: any) {
      this.$v.$reset()
      this.email = ''
      this.isUserAdmin = false
      this.isSubmit = false
      this.visible = true
      this.isGuest = group?.isGuest ?? false

      // 契約管理からの場合は選択したグループID、グループ設定からの場合は現在のグループID
      if (group?.id) {
        this.groupId = group.id
      } else {
        this.groupId = this.currentGroup?.id
      }
    },
    /**
     * ダイアログを閉じる
     */
    close() {
      this.visible = false
    }
  },
  validations: {
    email: {
      required,
      email
    }
  }
})
</script>
